import React, { useState, useEffect, useContext } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../../api/api';
import { useCookies } from 'react-cookie';

import { Auth } from '../../context/Auth';
import { UpdatePost } from '../../context/UpdatePostAfterUploading';

import Tablist from '../Tablist'
import '../../styles/componentsStyles/MyChannel/MyChannelLanding.scss'

// import Logo from "../../assets/logos/codemmit-logo.png"
import ContentCard from '../ContentCard'

const MyChannelLanding = () => {
  const [channelDetails, setchannelDetails] = useState({ channelName: "", logo: "", channelId: "", handle: "", about: "", followers: 0, posts: 0, ownerUserId: "" });
  const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);
  const auth = useContext(Auth);
  const updatePost = useContext(UpdatePost);

  const [activeTabContent, setActiveTabContent] = useState([]);

  // const { username } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idFromUrl = queryParams.get('id');

  useEffect(() => {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `${cookies.token}`
    };

    // Fetch Channel Details 
    axios.post(`${BASE_URL}/api/channels/fetch-channel`, {
      channelId: idFromUrl,
      requestingUserId: auth.authState.channelId ? auth.authState.channelId : "no-channel"
    }, { headers: headers })
      .then(res => {
        const data = res.data.channelData;
        console.log(res, "My Channel Fetched");
        setchannelDetails({ ...channelDetails, channelName: data.channelName, about: data.about, handle: data.channelHandle, logo: data.logo, followers: data.followers, posts: data.posts, ownerUserId: data.ownerUserId })
      })
      .catch(err => console.log(err, "Error!, Fecthing my channel details"))
  }, [auth.authState.channelId])

  // function for updating content, (This function is called from Tablist Component in order to update the content)
  const fetchContent = () => {
    const activeTab = JSON.parse(window.sessionStorage.getItem("activeTabDetail"));
    axios.post(`${BASE_URL}/api/posts/fetch-posts`, { channelId: idFromUrl, tabId: activeTab.id })
      .then(res => {
        if (res.data.statusText === "success") {
          setActiveTabContent(res.data.posts);
          console.log(res, "sgfsfgsggdf")
        } else {
          console.log(res, "Error fetching posts")
        }
      })
      .catch(err => console.log(err, "Error fetching posts"))
  }

  useEffect(() => {
    console.log("Hiiiiiii")
    if (updatePost.updatedPostState === true) {
      if (sessionStorage.getItem("activeTabDetail")) {
        const activeTab = window.sessionStorage.getItem("activeTabDetail") !== undefined && JSON.parse(window.sessionStorage.getItem("activeTabDetail"));
        axios.post(`${BASE_URL}/api/posts/fetch-posts`, { channelId: idFromUrl, tabId: activeTab.id })
          .then(res => {
            if (res.data.statusText === "success") {
              setActiveTabContent(res.data.posts);
              updatePost.updatePostDispatch({ type: "changeToDefaultState" })
              console.log(res, "updated posts after uploading new content");
            } else {
              console.log(res, "Error fetching posts")
            }
          })
          .catch(err => console.log(err, "Error fetching posts"))
      }
    }
  }, [updatePost.updatedPostState])

  return (
    <>
      {channelDetails.channelName ? <>
        <div className='my-channel'>
          <div className="my-channel__bio">
            <div className="my-channel__logo-container">
              <img className='my-channel__logo' src={channelDetails.logo} alt="logo" />
            </div>
            <div className="my-channel__about-channel">
              <h5>{channelDetails.channelName}</h5>
              <p>@{channelDetails.handle}  &#183; {channelDetails.followers} Followers  &#183; {channelDetails.posts} Posts</p>
              <p>{channelDetails.about}</p>
              <div className="my-channel__btn-container">
                <Link to="/chat" className='my-channel__action-btn'>
                  Follow
                </Link>
                {/* <Link to="/chat" className='my-channel__action-btn'>
                                Message
                            </Link> */}
              </div>
            </div>
          </div>
          {/* <div className="my-channel__detail">
                    <div className='my-channel__numbers-container'>
                        <div className="my-channel__numbers">
                            <h4>6556</h4>
                            <p>Following</p>
                        </div>
                        <div className="my-channel__numbers">
                            <h4>1056</h4>
                            <p>Follower</p>
                        </div>
                        <div className="my-channel__numbers">
                            <h4>150</h4>
                            <p>Posts</p>
                        </div>
                    </div>
                    <button className='my-channel__follow-btn'>Follow</button>
                </div> */}
        </div>
        <Tablist ownerUserId={channelDetails.ownerUserId} fetchContentData={fetchContent} />
        <div className="my-channel__contents">
          {
            activeTabContent.map(content => <ContentCard key={content.id} contentData={content} />)
          }

        </div>
      </> : <>
        <h1>Something went wrong!</h1>
      </>}

    </>
  )
}

export default MyChannelLanding